export default __webpack_public_path__ + "static/media/aol.5f459451.svg";